import React from "react";
import styles from './requestMobile.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { Camera, Plus, UploadCloud, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from 'react-smart-toaster';

const RequestMobile = ({ isPanelOpen, onToggle, requestData, setRequestData, setLoading, openResolve, isResolveOpen }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { user, isAuthenticated } = useAuth0();
  const [descVal, setDescVal] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState(0);

  useEffect(() => {
    if (requestData) {
      setDescVal(requestData?.description);
    }
  }, [requestData]);

  useEffect(() => {
    const handler = setTimeout(async () => {

      if (descVal !== '') {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, { description: descVal }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {

          setRequestData(prev => {
            return { ...prev, description: response.data.data?.description };
          });


        }).catch(() => { });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [descVal, getAccessTokenSilently]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setRequestData(prev => {
        if (deleteType === 1) {
          let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
          return { ...prev, resolve_images: images };
        } else {
          let images = prev?.images?.filter(i => i?.id !== deleteId);
          return { ...prev, images: images };
        }
      });

      let logData = {
        'title': 'Maintenance request image deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => { });
  }

  const fileHandler = async (e) => {
    let extErr = false;
    let sizeErr = false;
    let files = e.target.files;
    let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

    if (files.length > 0) {
      if (allowedExtensionArr.length > 0) {
        let fileName = files[0].name;
        let fileSize = files[0].size;
        let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        fileNameExt = '.' + fileNameExt;

        if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
          extErr = true;
        }

        if (fileSize >= 5242880) {
          sizeErr = true;
        }
      }
    }

    if (extErr) {
      toast.error("File type is not allowed.");
      return false;
    }

    if (sizeErr) {
      toast.error("File size should not be greater than 5 MB.");
      return false;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);

    let formData = new FormData();
    formData.append("image", files[0]);

    axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);

      setRequestData(prev => {
        let images = response.data.data.concat(prev?.images);
        return { ...prev, images: images };
      });

      let logData = {
        'title': 'Maintenance request image uploaded',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);

    }).catch(error => {
      setLoading(false);
    });
  }

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("two")}>
          <p className={`${styles.Title}`}>Request</p>
          <img src="/static/img/downTriangle.svg" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          <div className={`${styles.AccouFormGroup}`}>
            <form>
              <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                  <div className={`${styles.FormSec}`}>
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                      <label className={`${styles.FilterLabel}`}>Describe the Maintenance Issue</label>
                      <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}
                        onChange={(e) => {
                          setDescVal(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                    <label className={`${styles.FilterLabel}`}>Share a Documents/Photos</label>
                    <div className={`${styles.FileIMGDiv}`}>
                      {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                        {/* <label for="file-upload" className={`${styles.UploadLabel}`}>
                          <UploadCloud />
                          <p>Upload Documents/Photos</p>
                        </label> */}
                        {requestData?.images?.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Documents/Photos</label>)}
                        <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                        {requestData?.images?.length === 0 && (<p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG, PDF, DOC, XLX file only</p>)}
                      </div>}

                      <div className={`${styles.UpIMGSec}`}>
                        {requestData?.images?.map((item, index) => {
                          return (<div className={`${styles.ImgFile}`}>
                            {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/docIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/excelIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/pdfIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" />)))}
                            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <Button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}> <X /> </Button>}
                          </div>)
                        })}
                        {requestData?.images?.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>)}
                        {requestData?.images?.length === 0 && (
                          <div className={`${styles.NoImgDiv}`}>
                            <img src="/static/img/no-photo.png" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {/* <p className={`${styles.SummaryDetails}`}>pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.</p>
          <div className={`${styles.ReqDeAddBodyFile}`}>
              <p className={`${styles.FileTitle}`}>Images</p>
              <div className={`${styles.AddFormFileUP}`}>
                <img src="/static/img/ApartmentBedRoom.jpg" className={`${styles.UpIMG}`} />
              </div>
          </div> */}
          {!isResolveOpen && <button className={`${styles.ResolveBU}`} onClick={(e) => openResolve()}>Resolve</button>}
        </div>
      </div>

      <Dialog
        open={openDeleteModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RequestMobile;
